import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2827b8f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "white-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "white-card__title" }, "Индекс налёта", -1))
const _hoisted_3 = { class: "white-card__content" }
const _hoisted_4 = { class: "white-card__item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "white-card__text text-bold" }, "Индекс налёта:", -1))
const _hoisted_6 = { class: "white-card__text" }
const _hoisted_7 = { class: "white-card__item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "white-card__text text-bold" }, "Наличие зубного камня:", -1))
const _hoisted_9 = { class: "white-card__text" }
const _hoisted_10 = { class: "white-card__item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "white-card__text text-bold" }, " Наличие пигментированного налета: ", -1))
const _hoisted_12 = { class: "white-card__text" }


import { ScreeningControllerInterface } from '@/pages/ScreeningPage/screeningController'

interface Props {
  screeningController: ScreeningControllerInterface
}


export default /*#__PURE__*/_defineComponent({
  props: {
    screeningController: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.screeningController.plaqueIndex) + "%", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, _toDisplayString(__props.screeningController.teethStone ? 'Есть' : 'Нет'), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(__props.screeningController.pigmentedPlaque ? 'Есть' : 'Нет'), 1)
      ])
    ])
  ]))
}
}

})